/**
 * Account settings error shapes come from AppExceptionRenderer.php, which
 * turns Cake validator errors into `{ error: [{ field, messages }] }`. These
 * two helpers read that shape for the two call sites here: field-level
 * mapping for the edit form, and a flattened message for delete (whose
 * validator errors are keyed by "uuid", not a field a user would recognise).
 */

const KNOWN_FIELDS = ["first_name", "last_name", "email"];

export function parseEditError(error) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];

  const fieldErrors = {};
  entries.forEach(({ field, messages }) => {
    if (KNOWN_FIELDS.includes(field) && messages?.length) {
      fieldErrors[field] = messages[0];
    }
  });

  if (Object.keys(fieldErrors).length) {
    return { fieldErrors, generalMessage: null };
  }

  const generalMessage =
    data?.message ||
    error?.message ||
    "The service is unavailable. Your edits are still here — try again in a moment.";

  return { fieldErrors: {}, generalMessage };
}

export function parseGeneralError(error, fallback) {
  const data = error?.response?.data;
  const entries = Array.isArray(data?.error) ? data.error : [];
  const messages = entries.flatMap((entry) => entry.messages || []);

  if (messages.length) {
    return messages.join(" ");
  }

  return data?.message || error?.message || fallback;
}
